/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Risk_Short_LimitedInputs */



/**
* | output |
* | --- |
* | "Limited" |
*
* @param {Audit_Logs_Risk_Short_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_risk_short_limited = /** @type {((inputs?: Audit_Logs_Risk_Short_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Risk_Short_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Begrenzt")
	return /** @type {LocalizedString} */ ("Limited")
});